import { RoutePage } from './RoutePage';

const name = 'RoutePage';

export { RoutePage, name };
